import { forwardRef } from 'react'

import { IconWrapper } from './styled'

const IconToolTip = forwardRef(({ ...props }, ref) => {
  return (
    <IconWrapper ref={ref} {...props}>
      ?
    </IconWrapper>
  )
})

export default IconToolTip
